/**
 * Central application configuration constants.
 * All brand names, platform strings, and configurable values live here.
 * Override via environment variables where applicable.
 */

export const APP_NAME =
  process.env.NEXT_PUBLIC_APP_NAME || 'PREP Platform';

export const APP_URL =
  process.env.NEXT_PUBLIC_APP_URL || 'https://prepplatf2199.builtwithrocket.new';

export const APP_LOGO_PATH = '/assets/images/logo-1772762773445.png';

export const APP_TAGLINE = 'Plataforma de Recursos Estadísticos y Personal';

export const APP_DESCRIPTION = 'Gestión empresarial integral para empresas de software';

export const APP_COPYRIGHT_ENTITY = process.env.NEXT_PUBLIC_APP_COPYRIGHT || 'PREP Platform';

/** Default fallback company name shown in the super-admin sidebar */
export const SUPER_ADMIN_COMPANY_LABEL = APP_NAME;

/** Twilio sandbox number — override via TWILIO_WHATSAPP_FROM */
export const TWILIO_SANDBOX_NUMBER = 'whatsapp:+14155238886';
